import "./patches/consolePatch";

import React from "react";
import ReactDOM from "react-dom/client";
import moment from "moment";
import QueryString from "query-string";
import "moment/locale/zh-cn";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-datepicker/dist/react-datepicker.css";

import App from "./App";
import { DESKTOP_BUILD, PUBLIC_URL } from "./helpers/config";
import "./styles/index.css";
import "./styles/loader.css";
import "./styles/fonts.css";
import "./styles/markdown.css";
import reportWebVitals from "./reportWebVitals";
import testPatch from "./patches/testPatch";
import errorHandlePatch from "./patches/errorHandlePatch";
import rollbar from "./helpers/rollbar";
import { embedInMobile } from "helpers";

moment.locale("zh-cn");

testPatch();
errorHandlePatch();

window._fmsToken = localStorage.getItem("token");

const params = QueryString.parse(window.location.search);
if (params.token) {
  window._fmsToken = params.token;
  window._fmsTokenPersonified = true;
}

const root = ReactDOM.createRoot(document.getElementById("root"), {
  // Errors caught by an error boundary never reach window.onerror, so report
  // them explicitly. Uncaught render errors keep React's default handling
  // (rethrown globally), which Rollbar's captureUncaught picks up.
  onCaughtError: (error, errorInfo) => {
    // eslint-disable-next-line no-console
    console.error(error, errorInfo.componentStack);
    rollbar.error(error, { componentStack: errorInfo.componentStack });
  },
});
root.render(<App />);

if (embedInMobile)
  window.ReactNativeWebView?.postMessage(
    JSON.stringify({
      ready: true,
    }),
  );

if (!DESKTOP_BUILD && !embedInMobile) {
  reportWebVitals();
  if (
    window.location.origin.toLowerCase() !== PUBLIC_URL &&
    PUBLIC_URL.startsWith("http") // invalid PUBLIC_URL, e.g. in yarn start
  ) {
    const newUrl =
      PUBLIC_URL +
      window.location.href.substring(window.location.origin.length);
    window.location.href = newUrl;
  }
}
